import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';
import styles from '../RequestServiceSearchLoader.module.scss';
import { CustomStyledLabel } from '../../custom-styled-label/CustomStyledLabel';
import { RequestServiceStepIndicator } from '../../request-service-step-indicator/RequestServiceStepIndicator';
import { RequestServiceSearchLoaderMobileProps } from '../../types';

export const RequestServiceSearchLoaderMobile = ({
  className,
  descriptionLabel
}: RequestServiceSearchLoaderMobileProps) => {
  return (
    <div data-testid="requestServiceLoaderMobile">
      <div className="d-flex align-items-center flex-column">
        <div
          className={cx('mb-3', styles['equipment-info__image-loader-mobile'])}
        >
          <CatSkeleton />
        </div>
        <div className={styles['equipment-info__name-loader-mobile']}>
          <CatSkeleton size="sm" />
        </div>
        <div
          className={cx(
            'mb-4 pt-2',
            styles['equipment-info__serial-number-loader']
          )}
        >
          <CatSkeleton size="sm" />
        </div>
        <div className="mb-4 w-100">
          <CatSkeleton size="lg" />
          <CatSkeleton />
          <CatSkeleton size="sm" />
        </div>
      </div>
      <CatHeading variant="label">
        <CustomStyledLabel>{descriptionLabel}</CustomStyledLabel>
      </CatHeading>
      <div className="my-4">
        <CatSkeleton size="lg" />
        <CatSkeleton />
      </div>
      <RequestServiceStepIndicator classname={className} />
      <hr className={styles['bottom-verical-line']} />
    </div>
  );
};
